export default "__VITE_ASSET__DQYCfVW2__"